<div class="container">
    <div class="card shadow-lg p-4">
        <h2 class="mb-4 text-center">Customer Information</h2>

        <form [formGroup]="customerForm">
            <div class="row">
                <!-- Checkbox Selection -->
                <div class="mb-3">
                    <label class="form-label">Customer Type <span class="mandatory">*</span></label>
                    <div class="form-check form-check-inline">
                        <input class="form-check-input ms-3" type="radio" id="individual" value="1"
                            (change)="onCustomerTypeChange('1')" [checked]="customerType === 'individual'"
                            formControlName="userType">
                        <label class="form-check-label" for="individual">Individual</label>
                    </div>
                    <div class="form-check form-check-inline">
                        <input class="form-check-input" type="radio" id="corporate" value="2"
                            (change)="onCustomerTypeChange('2')" [checked]="customerType === 'corporate'"
                            formControlName="userType">
                        <label class="form-check-label" for="corporate">Corporate</label>
                    </div>
                </div>
                <div class="col-md-6">

                    <div class="mb-3">
                        <label class="form-label">Customer Name <span class="mandatory">*</span></label>
                        <input type="text" class="form-control" formControlName="customerName"
                            [ngClass]="{'is-invalid': customerForm.get('customerName')?.invalid && customerForm.get('customerName')?.touched, 
                                        'is-valid': customerForm.get('customerName')?.valid && customerForm.get('customerName')?.touched}" placeholder="Enter Name">
                        <div class="invalid-feedback">Required</div>
                        <div class="valid-feedback">Looks good!</div>
                    </div>

                    <div class="mb-3">
                        <label class="form-label">Address <span class="mandatory">*</span></label>
                        <textarea class="form-control" formControlName="address"
                            [ngClass]="{'is-invalid': customerForm.get('address')?.invalid && customerForm.get('address')?.touched, 
                                        'is-valid': customerForm.get('address')?.valid && customerForm.get('address')?.touched}" placeholder="Enter Address"></textarea>
                        <div class="invalid-feedback">Required</div>
                        <div class="valid-feedback">Looks good!</div>
                    </div>

                    <div class="mb-3">
                        <label class="form-label">Bank Name <span class="mandatory">*</span></label>
                        <input type="text" class="form-control" formControlName="bankName"
                            [ngClass]="{'is-invalid': customerForm.get('bankName')?.invalid && customerForm.get('bankName')?.touched, 
                                        'is-valid': customerForm.get('bankName')?.valid && customerForm.get('bankName')?.touched}" placeholder="Enter Bank Name">
                        <div class="invalid-feedback">Required</div>
                        <div class="valid-feedback">Looks good!</div>
                    </div>

                    <!-- CR Number (Visible only if Corporate) -->
                    <div class="mb-3" *ngIf="selectedType == '2'">
                        <label class="form-label">CR Number <span class="mandatory">*</span></label>
                        <input type="text" class="form-control" formControlName="crNumber"
                            [ngClass]="{'is-invalid': customerForm.get('ibanNumber')?.invalid && customerForm.get('ibanNumber')?.touched, 
                                        'is-valid': customerForm.get('ibanNumber')?.valid && customerForm.get('ibanNumber')?.touched}" placeholder="Enter Iban Number">
                        <div class="invalid-feedback">Required</div>
                        <div class="valid-feedback">Looks good!</div>
                    </div>

                    <!-- VAT Number (Visible only if Corporate) -->
                    <div class="mb-3" *ngIf="selectedType == '2'">
                        <label class="form-label">VAT Number <span class="mandatory">*</span></label>
                        <input type="text" class="form-control" formControlName="vatNumber"
                            [ngClass]="{'is-invalid': customerForm.get('vatNumber')?.invalid && customerForm.get('vatNumber')?.touched, 
                                        'is-valid': customerForm.get('vatNumber')?.valid && customerForm.get('vatNumber')?.touched}" placeholder="Enter VAT Number">
                        <div class="invalid-feedback">Required</div>
                        <div class="valid-feedback">Looks good!</div>
                    </div>


                    <div class="mb-3" *ngIf="selectedType == '2'">
                        <label class="form-label">IBAN Number <span class="mandatory">*</span></label>
                        <input type="text" class="form-control" formControlName="ibanNumber"
                            [ngClass]="{'is-invalid': customerForm.get('ibanNumber')?.invalid && customerForm.get('ibanNumber')?.touched, 
                                        'is-valid': customerForm.get('ibanNumber')?.valid && customerForm.get('ibanNumber')?.touched}" placeholder="Enter CR Number">
                        <div class="invalid-feedback">Required</div>
                        <div class="valid-feedback">Looks good!</div>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="mb-3">
                        <label class="form-label">Phone Number <span class="mandatory">*</span></label>
                        <input type="text" class="form-control" formControlName="phoneNumber"
                            [ngClass]="{'is-invalid': customerForm.get('phoneNumber')?.invalid && customerForm.get('phoneNumber')?.touched, 
                                        'is-valid': customerForm.get('phoneNumber')?.valid && customerForm.get('phoneNumber')?.touched}" placeholder="Enter Phone Number">
                        <div class="invalid-feedback">Must be a 10-digit number</div>
                        <div class="valid-feedback">Looks good!</div>
                    </div>

                    <div class="mb-3">
                        <label class="form-label">Email Address <span class="mandatory">*</span></label>
                        <input type="email" class="form-control" formControlName="emailAddress"
                            [ngClass]="{'is-invalid': customerForm.get('emailAddress')?.invalid && customerForm.get('emailAddress')?.touched, 
                                        'is-valid': customerForm.get('emailAddress')?.valid && customerForm.get('emailAddress')?.touched}" placeholder="Enter Email">
                        <div class="invalid-feedback">Invalid Email Address</div>
                        <div class="valid-feedback">Looks good!</div>
                    </div>

                    <div class="mb-3 mt-5">
                        <label class="form-label">Bank Proof <span class="mandatory">*</span></label>
                        <input type="file" class="form-control" id="bankFile">
                    </div>

                    <!-- CR File (Visible only if Corporate) -->
                    <div class="mb-3" *ngIf="selectedType == '2'">
                        <label class="form-label">CR File <span class="mandatory">*</span></label>
                        <input type="file" class="form-control" id="crFile">
                    </div>

                    <!-- VAT File (Visible only if Corporate) -->
                    <div class="mb-3" *ngIf="selectedType == '2'">
                        <label class="form-label">VAT File <span class="mandatory">*</span></label>
                        <input type="file" class="form-control" id="vatFile">
                    </div>
                </div>
            </div>

            <div class="text-center mt-3">
                <button type="submit" class="btn btn-primary px-5" (click)="onSubmit()">Save</button>
            </div>
        </form>

    </div>
</div>